<template>
  <div id="app" class="main-container">
    <GlobalLoading
      v-if="
        $store.state.modalStore.isGlobalLoading || $store.state.level1.isLoading
      "
    />
    <Navbar />
    <AdvanceSearch v-if="$store.state.searchStore.showModal" />
    <Login v-if="$store.state.showModalLogin" />
    <Forgot v-if="$store.state.showModalForgot" />
    <Reset v-if="$store.state.showModalReset" />
    <Notif v-if="$store.state.showModalNotif" />
    <div>
      <div>
        <MatrixLegalDoc />
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '@/components/utils/Navbar-v2'
import Footer from '@/components/utils/footer'

export default {
  head: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
      },
    ],
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Navbar,
    Footer,
    MatrixLegalDoc: () => import('@/components/masterdata/matrix/main.vue'),
    AdvanceSearch: () => import('@/components/modal/advanceSearch.vue'),
    Login: () => import('@/components/modal/Login.vue'),
    Forgot: () => import('@/components/modal/forgot.vue'),
    Reset: () => import('@/components/modal/reset.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  created() {
    const self = this
    self.$store.commit('AUTO_LOGIN')
  },
}
</script>
